import { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux"
// store
import AppStore from "@/app-store";
import Store from "@/core/reducers/SimpleServiceStore";
// actions
import ClientMenuItemsServiceAction from "@/cms/actions/services/ClientMenuItemsServiceAction";
// types
import TOdataQueryOptions from "@/core/types/TOdataQueryOptions";
import TClientMenuItemList from "@/cms/types/TClientMenuItemList";
// enums
import EContentStatus from "@/cms/enums/EContentStatus";
import { isEmpty } from "lodash";


const useMenuItems = ( unqKey:string, mapLayoutName?:string ):TClientMenuItemList[]|null => {
    const dispatch = useDispatch();

    const clientMenuItemsServiceAction = new ClientMenuItemsServiceAction(dispatch, unqKey);
    AppStore.reducerManager.add(unqKey, Store(unqKey, clientMenuItemsServiceAction.serviceCode));
    const payload = useSelector((state:any) => state?.[unqKey]?.list?.payload, shallowEqual);
    const webApplicationLanguageCode = useSelector((state:any) => state.CoreStore.language?.payload?.code, shallowEqual);

    useEffect(() => { if ( mapLayoutName ) _list(); }, [mapLayoutName])

    const _list = () => {
        let queryOptions:TOdataQueryOptions = {
            filter: [`status eq ${EContentStatus.ACTIVE}`, "and", `mapLayoutName eq '${mapLayoutName}'`],
            orderBy: ["order asc"],
            top: 1000
        }
        clientMenuItemsServiceAction.search({ servicePayload: { queryOptions, language: webApplicationLanguageCode } });
    }
    
    if ( !isEmpty(payload) ) return payload;
    return null;
}

export default useMenuItems;
